import TeamsAPI from '../../api/teams';

export const SET_TEAM_MEMBERS_UI_FLAG = 'SET_TEAM_MEMBERS_UI_FLAG';
export const ADD_AGENTS_TO_TEAM = 'ADD_AGENTS_TO_TEAM';
export const SET_MEMBER_ROLE = 'SET_MEMBER_ROLE'; // Aceleres — Fase 2
export const SET_MEMBER_ROTATION = 'SET_MEMBER_ROTATION'; // Aceleres — Fase 3

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getTeamMembers: $state => id => {
    return $state.records[id] || [];
  },
};

export const actions = {
  get: async ({ commit }, { teamId }) => {
    commit(SET_TEAM_MEMBERS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await TeamsAPI.getAgents({ teamId });
      commit(ADD_AGENTS_TO_TEAM, { data, teamId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_TEAM_MEMBERS_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, { agentsList, teamId }) => {
    commit(SET_TEAM_MEMBERS_UI_FLAG, { isCreating: true });
    try {
      const { data } = await TeamsAPI.addAgents({ agentsList, teamId });
      commit(ADD_AGENTS_TO_TEAM, { teamId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_TEAM_MEMBERS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { agentsList, teamId }) => {
    commit(SET_TEAM_MEMBERS_UI_FLAG, { isUpdating: true });
    try {
      const response = await TeamsAPI.updateAgents({
        agentsList,
        teamId,
      });
      commit(ADD_AGENTS_TO_TEAM, response);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_TEAM_MEMBERS_UI_FLAG, { isUpdating: false });
    }
  },
  // Aceleres — Fase 2: define o papel (user|supervisor) de um membro via PATCH.
  setRole: async ({ commit }, { teamId, userId, role }) => {
    commit(SET_TEAM_MEMBERS_UI_FLAG, { isUpdating: true });
    try {
      await TeamsAPI.updateMemberRole({ teamId, userId, role });
      commit(SET_MEMBER_ROLE, { teamId, userId, role });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_TEAM_MEMBERS_UI_FLAG, { isUpdating: false });
    }
  },
  // Aceleres — Fase 3: ativa/desativa a participação no rodízio por equipe.
  setRotationEnabled: async ({ commit }, { teamId, userId, enabled }) => {
    commit(SET_TEAM_MEMBERS_UI_FLAG, { isUpdating: true });
    try {
      await TeamsAPI.updateMemberRotation({ teamId, userId, enabled });
      commit(SET_MEMBER_ROTATION, { teamId, userId, enabled });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_TEAM_MEMBERS_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [SET_TEAM_MEMBERS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [ADD_AGENTS_TO_TEAM]($state, { data, teamId }) {
    $state.records = {
      ...$state.records,
      [teamId]: data,
    };
  },
  // Aceleres — Fase 2: atualiza o aceleres_role de um membro no record local.
  [SET_MEMBER_ROLE]($state, { teamId, userId, role }) {
    const list = $state.records[teamId];
    if (!list) return;
    $state.records = {
      ...$state.records,
      [teamId]: list.map(agent =>
        agent.id === userId ? { ...agent, aceleres_role: role } : agent
      ),
    };
  },
  // Aceleres — Fase 3: atualiza a participação no rodízio no record local.
  [SET_MEMBER_ROTATION]($state, { teamId, userId, enabled }) {
    const list = $state.records[teamId];
    if (!list) return;
    $state.records = {
      ...$state.records,
      [teamId]: list.map(agent =>
        agent.id === userId
          ? { ...agent, aceleres_rotation_enabled: enabled }
          : agent
      ),
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
